let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fIKES")).then(() => parcelRequire('l4cPj'));